import styled from "styled-components";
import InputWithIcon from "./InputWithIcon";
const ErrorInputWithIcon = styled(InputWithIcon)<{ valid: boolean }>`
  border: ${(props) =>
    props.valid ? "border: 1.5px solid #575dfb": "3px solid #FB4EFF"};
  &:focus {
    outline: none;
  }
`;
export default ErrorInputWithIcon